import { takeEvery, put, call } from 'redux-saga/effects';
import { APPLICATION_JSON, CONTENT_TYPE } from '../../shared/api/headers';
import { GET_IDENTITY_PROVIDERS_DATA, DEFAULT_BASE_URL } from '../../shared/api/urls';
import { apiRequest } from '../../shared/api';
import { setIdentityProvidersAction } from '../../actions/actionCreators';
import { GET_IDENTITY_PROVIDERS } from '../../actions/actionTypes';

function* getIdentityProvidersAsync() {
    const requestConfig = {
        headers: {
            [CONTENT_TYPE]: APPLICATION_JSON,
        },
        baseURL: DEFAULT_BASE_URL,
        url: GET_IDENTITY_PROVIDERS_DATA,
    };

    try {
        const { data } = yield call(apiRequest, requestConfig);
        yield put(setIdentityProvidersAction(data));
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
    }
}

export default function* watchGetIdentityProviders() {
    yield takeEvery(GET_IDENTITY_PROVIDERS, getIdentityProvidersAsync);
}
